import React from "react"
import { DevicePhoneMobileIcon } from "@heroicons/react/24/outline"

/**
 * Display component showing user devices count with click to view
 */
const UserDevices = ({ user, onViewDevices }) => {
  const deviceCount = user.devices?.length || 0

  return (
    <button
      className="flex items-center gap-1 text-admin_primary hover:text-admin_primary/80 whitespace-nowrap"
      onClick={() => onViewDevices(user)}
      disabled={deviceCount === 0}
    >
      <DevicePhoneMobileIcon className="hidden xl:block w-4 h-4" />
      {deviceCount} device{deviceCount !== 1 ? 's' : ''}
    </button>
  )
}

export default UserDevices
